import NavCategories from './NavCategories';

export default NavCategories;
